module.exports = __webpack_public_path__ + "img/home_15.dfdcc62b.svg";